import Cookies from "js-cookie";
import { handleDownload } from "../Utils/FileDownloadManager";
import { ViewDocument } from "../Utils/DocsManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faArrowRightToBracket,
  faFileSignature,
  faArrowRightFromBracket,
  faRotate,
} from "@fortawesome/free-solid-svg-icons";
import { displayInputData } from "../Utils/DocsManager";
import { getJdataADM } from "../../AdminAPI/DocJdataADM";
import { handleCheckboxChange } from "../Utils/DocsManager";

const Token = Cookies.get("Token");
const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const renderDataCellDocsAdm = (item, col, context, idx) => {
  const value = getNestedValue(item, col.key);

  switch (col.admData) {
    case "Admin actions":
      return (
        <td key={`actions-${idx}`}>
          <button
            className="btn ActionsButton"
            title={context.t("Relaunch selected docs")}
            onClick={() =>
              context.handleRelaunchClick(context.selectedDocuments)
            }
            disabled={context.selectedDocuments.length === 0}
          >
            <FontAwesomeIcon
              icon={faRotate}
              style={{ marginRight: "5px" }}
              className="fa-copy"
            />
          </button>
        </td>
      );
    default:
      return (
        <td
          key={`default-${idx}`}
          style={{
            fontWeight: col.bold ? "bold" : "normal",
            width: "100px",
            fontSize: "14px",
          }}
        >
          {value}
        </td>
      );
  }
};
